



















import { isEmpty, isNil } from 'lodash';
import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';

@Component
export default class CaptionedField extends Vue {
	@Prop({ type: String }) captionLocale!: string;
	@Prop({ type: Boolean, default: false }) required!: boolean;
	@Prop({ type: String }) helpTextLocale!: string;

	get caption() {
		return this.$t(this.captionLocale);
	}

	get isHelpTextDefined() {
		return !isNil(this.helpTextLocale) && !isEmpty(this.helpTextLocale);
	}
}
